import { FC, useEffect, useState } from "react";
import { FormContainerStateReturnType, useTrans } from "../../../hooks";
import { useToast } from "@chakra-ui/react";
import {
    Company,
    CompanyApi,
    InternshipScheduleSeat as Entity,
    InternshipScheduleSeatApi as EntityApi,
    Internship,
    InternshipSchedule,
    InternshipScheduleApi,
    User,
    UserApi,
} from "../../../apis";
import { AppFormContainer } from "../../../containers";
import { AppLoader } from "../../../components";
import { APPC } from "../../../config";
import { InternshipDetailView } from "./InternshipDetailView";

export const MyInternshipForm: FC<{
    formContainerState: FormContainerStateReturnType;
    isDetailPage: boolean;
    entityType: "InternshipSchedule" | "InternshipScheduleSeat";
    cId?: number;
}> = ({ formContainerState, isDetailPage, entityType, cId }) => {
    // hook
    const { t } = useTrans();
    const toast = useToast();

    // state & const
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<Entity>(new Entity());
    const [internshipCoordinator, setInternshipCoordinator] = useState<User[]>(
        []
    );
    const USERTYPE = APPC.BE.User.USERTYPE;
    const isInternshipScheduleSeat = entityType === "InternshipScheduleSeat";

    // useEffect
    useEffect(() => {
        if (!formContainerState.entityId) {
            setData(new Entity());
            setLoading(false);
            return;
        }
        setLoading(true);
        const api = isInternshipScheduleSeat
            ? EntityApi
            : InternshipScheduleApi;
        const method = isInternshipScheduleSeat
            ? "getItemMyInternship"
            : "getItem";
        const apiType = isInternshipScheduleSeat ? Entity : InternshipSchedule;

        api[method]<typeof apiType>(formContainerState.entityId)
            .then(({ errorMessage, isNotFound, response }) => {
                if (errorMessage) {
                    toast({
                        title: errorMessage,
                        status: "error",
                    });
                } else if (isNotFound) {
                    toast({
                        title: t("cmn:message.entityNotFound"),
                        status: "error",
                    });
                } else if (response !== null) {
                    if (isInternshipScheduleSeat) {
                        setData(response);
                    } else {
                        const data = {} as Entity;
                        data.internshipSchedule = response;
                        data.noOfSeats = 0;
                        setData(data);
                    }

                    const companyId = isInternshipScheduleSeat
                        ? (
                              (
                                  (
                                      response?.internshipSchedule as InternshipSchedule
                                  )?.internship as Internship
                              )?.company as Company
                          )?.["@id"]
                        : CompanyApi.toResourceIRI(cId);

                    if (companyId) {
                        const params = {
                            [`order[name]`]: "asc",
                            pagination: false,
                            userType: [
                                USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR,
                                USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
                            ],
                            ["companies.id"]: companyId,
                        };
                        UserApi.getCollectionCoordinator<User>(1, params).then(
                            ({ response }) => {
                                if (response !== null) {
                                    setInternshipCoordinator(response?.items);
                                }
                            }
                        );
                    }
                }
            })
            .finally(() => setLoading(false));
    }, [formContainerState.entityId]);

    if (loading) {
        <AppLoader />;
    }

    return (
        <AppFormContainer
            title={t("padm.InternshipForm:text.pageTitle")}
            state={formContainerState}
            type={APPC.FORM_CONTAINER}
            size="xl"
            isFooter={!isDetailPage}
        >
            <InternshipDetailView
                data={data}
                internshipCoordinator={internshipCoordinator}
            />
        </AppFormContainer>
    );
};
